module.exports = __webpack_public_path__ + "assets/loop-setting.b909ad5a.svg";